/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-accordion component
 */

@use "../zr-theme/zr-variables.scss" as *;
@use "../zr-css-icon/zr-css-icon.scss" as i;
@use "../zr-theme/functions/fonts" as f;
@use "../zr-theme/fonts/open-sans.scss";

// component name
$component: 'zr-accordion';

// component vars defaults
:host {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    margin-top: 16px;
    display: block;

    &:first-child {
        margin-top: 0;
    }

    .pdf-link {
        vertical-align: middle;

        img {
            width: 20px;
            float: left;
            margin-right: 10px;
        }
    }
}

.#{$component}__header {
    .is-active & {
        margin-bottom: 24px;
    }
}

.#{$component}__header-text {
    @include i.get-icon-right(arrow-down);

    transition: color .2s ease-out;

    font-size: f.calc-em(16);
    line-height: f.calc-em(24);
    font-weight: 700;
    color: var(--ci-neutral900);
    margin: 0;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    background: none;
    border: none;
    width: 100%;

    &::after {
        transform: rotate(0deg);
        transition: transform .15s ease-out;

        height: 20px;
        width: 20px;
        position: relative;
        top: 4px;
    }

    &:focus-visible {
        color: var(--ci-primary400);
    }

    .is-active & {
        &::after {
            transform: rotate(180deg);
        }
    }
}

.#{$component}__panel {
    transition: max-height .15s ease-out;
    max-height: 0;
    overflow: hidden;

    .is-active & {
        max-height: 10000px;
        transition: max-height .25s ease-in;
    }
}

// media query: tablet and above
@media only screen and (min-width: $tablet-screen) {
    .#{$component}__header-text {
        font-size: f.calc-em(20);
        line-height: f.calc-em(28);

        &:hover {
            color: var(--ci-primary400);
        }

        &::after {
            top: 15px;
        }
    }
}



